import { type RouteObject } from 'react-router';
import { standaloneLayout } from '@/app/layouts';
import { ROUTES } from '@/shared/routing';

/**
 * 공개 고객지원 화면 — `/help`. App Store Connect · Play Console 에 제출하는 **Support URL** 목적지.
 *
 * public(비인증) — 심사자는 로그인하지 않고 이 URL 을 연다. 앱 본체 `/support` 는 `createAppRoute` 자식이라
 * `requireAuth`·`requireConsent` 게이트를 지나야 해서 심사 표면으로 쓸 수 없다(그래서 화면을 옮기지 않고
 * 공개 표면을 따로 세운다 — 옮기면 앱 고객센터 탭이 AppLayout chrome 을 잃는다).
 *
 * **web 전용** — 앱에는 이미 `/support` 가 있고, 이 화면의 앱 다운로드 유도는 앱 안에서 의미가 없다.
 * subscription 과 같은 방식으로 build target 게이트(모바일 빌드에선 null → 트리에서 제외)를 건다.
 */
export function createHelpRoute(): RouteObject | null {
  if (import.meta.env.VITE_BUILD_TARGET !== 'web') return null;

  return {
    element: standaloneLayout({ width: 'sm' }),
    path: ROUTES.HELP,
    children: [
      {
        index: true,
        lazy: { Component: () => import('@/pages/help').then((m) => m.HelpPage) },
      },
    ],
  };
}
